var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('job-alert-form',{attrs:{"data":_vm.jobAlert,"title":_vm.$t('jobAlert.edit.title'),"submit-loading":_vm.submitLoading},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }